
export default `mutation changeCustomerPassword($currentPassword: String!, $newPassword: String!) {
  changeCustomerPassword(currentPassword: $currentPassword, newPassword: $newPassword) {
    lastname
  }
}`
